import getConfig from 'next/config';

const env = getConfig()?.publicRuntimeConfig;

export const Weekdays = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday'
];

export const DateSeriesRepeatCycle = [
  'daily_mo_to_fr',
  'daily_mo_to_sa',
  'daily',
  'weekly',
  'bi_weekly',
  // 'monthly',
  'monthly_first',
  'monthly_second',
  'monthly_third',
  'monthly_fourth'
];

export const Occupancies = env?.settingHolidayUse
  ? ['permanent', 'single', 'holiday']
  : ['permanent', 'single'];

export const Closures = ['permanent', 'single'];

export const OccupancyTypes = [
  'training',
  'competition',
  'large_event',
  'other',
  'school'
];

export const ClosureTypes = [
  'accident',
  'already_occupied',
  'care',
  'free_use',
  'maintenance',
  'miscellaneous',
  'no_operation_bridging_day',
  'no_operation_holiday',
  'no_operation_other',
  'no_operation_vacation',
  'point_game_operation',
  'refurbishment',
  'regeneration',
  'renovation',
  'reservation',
  'ventilation',
  'weather'
];

export const ConsumerMemberRoles = [
  // 'owner',
  'admin',
  'booking_applicant',
  'booking_trainer'
];
export const ConsumerMemberTypes = ['general_manager', 'manager', 'trainer'];

export const ProviderMemberRoles = [
  // 'owner',
  'admin',
  'booking_admin'
  // 'facility_manager'
];

export const ProviderCategories = [
  'administration_bookings',
  'administration_facilities',
  'administration_sports_funding'
];

export const OrganizationMemberRoles = ['owner', 'admin'];

export const RequestStatus = [
  'draft',
  'new',
  'withdrawn',
  'rejected',
  'in_progress',
  'completed'
];

export const BookingStatus = [
  'new',
  'in_progress',
  'locked',
  'completed',
  'all'
];

export const StatisticNames = [
  '01_bookings_by_type',
  '02_closures_by_type',
  '03_bookings_by_consumer_and_type',
  '04_booking_requests_of_award_process',
  '05_bookings_of_award_process',
  '06_closures_of_award_process',
  '07_bookings_and_free_capacity_by_group',
  '09.1_domains',
  '09.2_groups'
];

export const ConsumerTypes = [
  'association',
  'sports_club',
  'other',
  'school',
  'company',
  'person',
  'church',
  'city',
  'company_sports',
  'kindergarten',
  'municipal_organization',
  'university'
];

export const ProviderTypes = ['district', 'state', 'other'];

export const GroupTypes = [
  { name: 'bowling_facility', covered: true },
  { name: 'circular_track_400m', covered: false },
  { name: 'combination_bath', covered: null },
  { name: 'equestrian_facility', covered: false },
  { name: 'fitness_and_weight_room', covered: true },
  { name: 'gymnastics_meadow', covered: false },
  { name: 'hall_size_1_gte_10m_12m_lt_15m_27m', covered: true },
  { name: 'hall_size_2_gte_15m_27m_lt_22m_44m', covered: true },
  { name: 'hall_size_3_gte_22m_44m_lt_27m_45m', covered: true },
  { name: 'hall_size_4_gte_27_45', covered: true },
  { name: 'ice_rink', covered: null },
  { name: 'indoor_swimming_pool', covered: true },
  { name: 'laea_jumping', covered: false },
  { name: 'laea_other_circular_track', covered: false },
  { name: 'laea_shot_put', covered: false },
  { name: 'laea_throw', covered: false },
  { name: 'laea_track', covered: false },
  { name: 'large_playing_field', covered: false },
  { name: 'not_specified', covered: null },
  { name: 'other_core_sports_facility', covered: false },
  { name: 'outdoor_swimming_pool', covered: false },
  { name: 'shooting_range', covered: null },
  { name: 'small_hall_sports_room', covered: true },
  { name: 'small_playing_field', covered: false },
  { name: 'summer_pool', covered: false },
  { name: 'teaching_swimming_and_therapy_pools', covered: true },
  { name: 'tennis_court', covered: false },
  { name: 'tennis_hall', covered: true },
  { name: 'water_sports_facility', covered: false },
  { name: 'youth_and_multi_purpose_room', covered: true }
];

export const GroupTypesPortal = [
  { name: 'bowling_facility', covered: true },
  { name: 'circular_track_400m', covered: false },
  { name: 'equestrian_facility', covered: false },
  { name: 'fitness_and_weight_room', covered: true },
  { name: 'gymnastics_meadow', covered: false },
  { name: 'hall_size_1_gte_10m_12m_lt_15m_27m', covered: true },
  { name: 'hall_size_2_gte_15m_27m_lt_22m_44m', covered: true },
  { name: 'hall_size_3_gte_22m_44m_lt_27m_45m', covered: true },
  { name: 'hall_size_4_gte_27_45', covered: true },
  { name: 'ice_rink', covered: null },
  { name: 'laea_jumping', covered: false },
  { name: 'laea_other_circular_track', covered: false },
  { name: 'laea_shot_put', covered: false },
  { name: 'laea_throw', covered: false },
  { name: 'laea_track', covered: false },
  { name: 'large_playing_field', covered: false },
  { name: 'not_specified', covered: null },
  { name: 'other_core_sports_facility', covered: false },
  { name: 'shooting_range', covered: null },
  { name: 'small_hall_sports_room', covered: true },
  { name: 'small_playing_field', covered: false },
  { name: 'teaching_swimming_and_therapy_pools', covered: true },
  { name: 'tennis_court', covered: false },
  { name: 'tennis_hall', covered: true },
  { name: 'water_sports_facility', covered: false },
  { name: 'youth_and_multi_purpose_room', covered: true }
];

export const GroupCoverages = ['covered', 'not_covered'];

export const GroupFloorings = [
  { name: 'wood', covered: true },
  { name: 'linoleum', covered: true },
  { name: 'parquet', covered: true },
  { name: 'plastic', covered: true },
  { name: 'other_coverings', covered: null },
  { name: 'ice', covered: null },
  { name: 'without_information', covered: null },
  { name: 'mix', covered: false },
  { name: 'concrete', covered: false },
  { name: 'mastic_asphalt', covered: false },
  { name: 'synthetic_turf_granulate_filled', covered: false },
  { name: 'synthetic_turf_quartz_sand_filled', covered: false },
  { name: 'synthetic_turf_unfilled', covered: false },
  { name: 'natural_grass', covered: false },
  { name: 'sand', covered: false },
  { name: 'threshing_floor', covered: false }
];

export const DomainProperties = ['federal', 'state', 'private', 'sports_club'];

export const DomainAdministeringInstitutions = [
  'district',
  'state',
  'private',
  'sports_club'
];

export const DomainOperatingInstitutions = [
  'district',
  'no_operator',
  'state',
  'private',
  'sports_club'
];

export const ConsumerAccountStatus = [
  'active',
  'failed',
  'locked',
  'no',
  'not_confirmed'
];

export const ConsumerSportsSponsorshipWorthiness = [
  'open',
  'acknowledged',
  'repudiated',
  'excluded'
];

export const ConsumerCommercialRegister = [
  'hra',
  'hrb',
  'gnr',
  'gsr',
  'pr',
  'vr'
];

export const ConsumerDistrictCourts = [
  { name: 'Aachen', id: 1 },
  { name: 'Altenburg', id: 2 },
  { name: 'Amberg', id: 3 },
  { name: 'Ansbach', id: 4 },
  { name: 'Apolda', id: 5 },
  { name: 'Arnsberg', id: 6 },
  { name: 'Arnstadt', id: 7 },
  { name: 'Arnstadt Zweigstelle Ilmenau', id: 8 },
  { name: 'Aschaffenburg', id: 9 },
  { name: 'Augsburg', id: 10 },
  { name: 'Aurich', id: 11 },
  { name: 'Bad Hersfeld', id: 12 },
  { name: 'Bad Homburg v.d.H.', id: 13 },
  { name: 'Bad Kreuznach', id: 14 },
  { name: 'Bad Oeynhausen', id: 15 },
  { name: 'Bad Salzungen', id: 16 },
  { name: 'Bamberg', id: 17 },
  { name: 'Bayreuth', id: 18 },
  { name: 'Berlin (Charlottenburg)', id: 19 },
  { name: 'Bielefeld', id: 20 },
  { name: 'Bochum', id: 21 },
  { name: 'Bonn', id: 22 },
  { name: 'Braunschweig', id: 23 },
  { name: 'Bremen', id: 24 },
  { name: 'Chemnitz', id: 25 },
  { name: 'Coburg', id: 26 },
  { name: 'Coesfeld', id: 27 },
  { name: 'Cottbus', id: 28 },
  { name: 'Darmstadt', id: 29 },
  { name: 'Deggendorf', id: 30 },
  { name: 'Dortmund', id: 31 },
  { name: 'Dresden', id: 32 },
  { name: 'Duisburg', id: 33 },
  { name: 'Düren', id: 34 },
  { name: 'Düsseldorf', id: 35 },
  { name: 'Eisenach', id: 36 },
  { name: 'Erfurt', id: 37 },
  { name: 'Eschwege', id: 38 },
  { name: 'Essen', id: 39 },
  { name: 'Flensburg', id: 40 },
  { name: 'Frankfurt am Main', id: 41 },
  { name: 'Frankfurt/Oder', id: 42 },
  { name: 'Freiburg', id: 43 },
  { name: 'Friedberg', id: 44 },
  { name: 'Fritzlar', id: 45 },
  { name: 'Fulda', id: 46 },
  { name: 'Fürth', id: 47 },
  { name: 'Gelsenkirchen', id: 48 },
  { name: 'Gera', id: 49 },
  { name: 'Gießen', id: 50 },
  { name: 'Gotha', id: 51 },
  { name: 'Göttingen', id: 52 },
  { name: 'Greiz', id: 53 },
  { name: 'Gütersloh', id: 54 },
  { name: 'Hagen', id: 55 },
  { name: 'Hamburg', id: 56 },
  { name: 'Hamm', id: 57 },
  { name: 'Hanau', id: 58 },
  { name: 'Hannover', id: 59 },
  { name: 'Heilbad Heiligenstadt', id: 60 },
  { name: 'Hildburghausen', id: 61 },
  { name: 'Hildesheim', id: 62 },
  { name: 'Hof', id: 63 },
  { name: 'Homburg', id: 64 },
  { name: 'Ingolstadt', id: 65 },
  { name: 'Iserlohn', id: 66 },
  { name: 'Jena', id: 67 },
  { name: 'Kaiserslautern', id: 68 },
  { name: 'Kassel', id: 69 },
  { name: 'Kempten (Allgäu)', id: 70 },
  { name: 'Kiel', id: 71 },
  { name: 'Kleve', id: 72 },
  { name: 'Koblenz', id: 73 },
  { name: 'Köln', id: 74 },
  { name: 'Königstein', id: 75 },
  { name: 'Korbach', id: 76 },
  { name: 'Krefeld', id: 77 },
  { name: 'Landau', id: 78 },
  { name: 'Landshut', id: 79 },
  { name: 'Langenfeld', id: 80 },
  { name: 'Lebach', id: 81 },
  { name: 'Leipzig', id: 82 },
  { name: 'Lemgo', id: 83 },
  { name: 'Limburg', id: 84 },
  { name: 'Lübeck', id: 85 },
  { name: 'Ludwigshafen a.Rhein (Ludwigshafen)', id: 86 },
  { name: 'Lüneburg', id: 87 },
  { name: 'Mainz', id: 88 },
  { name: 'Mannheim', id: 89 },
  { name: 'Marburg', id: 90 },
  { name: 'Meiningen', id: 91 },
  { name: 'Memmingen', id: 92 },
  { name: 'Merzig', id: 93 },
  { name: 'Mönchengladbach', id: 94 },
  { name: 'Montabaur', id: 95 },
  { name: 'Mühlhausen', id: 96 },
  { name: 'München', id: 97 },
  { name: 'Münster', id: 98 },
  { name: 'Neubrandenburg', id: 99 },
  { name: 'Neunkirchen', id: 100 },
  { name: 'Neuruppin', id: 101 },
  { name: 'Neuss', id: 102 },
  { name: 'Nordhausen', id: 103 },
  { name: 'Nürnberg', id: 104 },
  { name: 'Offenbach am Main', id: 105 },
  { name: 'Oldenburg (Oldenburg)', id: 106 },
  { name: 'Osnabrück', id: 107 },
  { name: 'Ottweiler', id: 108 },
  { name: 'Paderborn', id: 109 },
  { name: 'Passau', id: 110 },
  { name: 'Pinneberg', id: 111 },
  { name: 'Pößneck', id: 112 },
  { name: 'Pößneck Zweigstelle Bad Lobenstein', id: 113 },
  { name: 'Potsdam', id: 114 },
  { name: 'Recklinghausen', id: 115 },
  { name: 'Regensburg', id: 116 },
  { name: 'Rostock', id: 117 },
  { name: 'Rudolstadt', id: 118 },
  { name: 'Saarbrücken', id: 119 },
  { name: 'Saarlouis', id: 120 },
  { name: 'Schweinfurt', id: 121 },
  { name: 'Schwerin', id: 122 },
  { name: 'Siegburg', id: 123 },
  { name: 'Siegen', id: 124 },
  { name: 'Sömmerda', id: 125 },
  { name: 'Sondershausen', id: 126 },
  { name: 'Sonneberg', id: 127 },
  { name: 'Stadthagen', id: 128 },
  { name: 'Stadtroda', id: 129 },
  { name: 'Steinfurt', id: 130 },
  { name: 'Stendal', id: 131 },
  { name: 'St. Ingbert (St Ingbert)', id: 132 },
  { name: 'Stralsund', id: 133 },
  { name: 'Straubing', id: 134 },
  { name: 'Stuttgart', id: 135 },
  { name: 'St. Wendel (St Wendel)', id: 136 },
  { name: 'Suhl', id: 137 },
  { name: 'Tostedt', id: 138 },
  { name: 'Traunstein', id: 139 },
  { name: 'Ulm', id: 140 },
  { name: 'Völklingen', id: 141 },
  { name: 'Walsrode', id: 142 },
  { name: 'Weiden i. d. OPf.', id: 143 },
  { name: 'Weimar', id: 144 },
  { name: 'Wetzlar', id: 145 },
  { name: 'Wiesbaden', id: 146 },
  { name: 'Wittlich', id: 147 },
  { name: 'Wuppertal', id: 148 },
  { name: 'Würzburg', id: 149 },
  { name: 'Zweibrücken', id: 150 }
];
